<div class="wrapper">
  <div class="table-container" id="schedule-table-container">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="stopFilter"
        [ngModelOptions]="{ standalone: true }"
      >
      {{'Show passes' | translate}}
    </label>
    <table class="table table-sm" *qmLoading="loading;config:loadingConfig">
      <thead>
      <tr>
        <th style="width: 65px;">
          {{'Station' | translate}}
        </th>
        <th style="width: 70px;">
          {{'Track' | translate}}
        </th>
        <th style="width: 90px;">
          {{'Stop' | translate}}
        </th>
        <th style="width: 170px;">
          <i class="far fa-arrow-to-right"></i>
        </th>
        <th>
          {{'Cause' | translate}}
        </th>
      </tr>
      </thead>
      <tbody id="schedule-table-tbody">
      <ng-template ngFor let-timetableRow let-i="index" [ngForOf]="timetableRows">
        <tr id="element-{{timetableRow.station}}" *ngIf="stopVisible(timetableRow) && (timetableRow.type === 'ARRIVAL' || i === 0)"
            [ngClass]="getRowClass(timetableRow, i)">
          <td style="width: 70px">{{timetableRow.station}}</td>
          <td style="width: 70px">
            {{timetableRow.track}}
          </td>
          <td style="width: 90px">
            <ng-container *ngIf="!timetableRow.stop; else commercialBlock;">
              -
            </ng-container>
            <ng-template #commercialBlock>
              {{timetableRow.commercial ? ('Yes' | translate) : ('No' | translate)}}
            </ng-template>
          </td>
          <td style="width: 170px">
            <div *ngIf="!timetableRow.begin">
              {{timetableRow.schedule | qmDateFormat:'HH:mm'}}
              <ng-container *ngIf="timetableRow.actual; else arrElseBlock">
                <i class="far fa-arrow-right"></i>
                {{timetableRow.actual | qmDateFormat:'HH:mm'}}
                <span class="badge badge-pill" [ngClass]="getDeltaClass(timetableRow.diff, true)"><span>{{timetableRow.diff}}</span></span>
              </ng-container>
              <ng-template #arrElseBlock>
                <span [ngClass]="getDeltaClass(timetableRow.diff, false)">
                  {{getForecast(timetableRow.schedule, timetableRow.diff)}}
                </span>
              </ng-template>
            </div>
          </td>
          <td>
            <ng-container *ngIf="!timetableRow.stop && latestStation(timetableRow)">
              {{'Arrived' | translate}}
            </ng-container>
            {{getCause(timetableRow)}}
          </td>
        </tr>
        <tr *ngIf="stopVisible(timetableRow) && timetableRow.type === 'DEPARTURE' && i !== 0" style="border: none;"
            [ngClass]="getRowClass(timetableRow, i)">
          <td style="width: 70px;" class="border-top-0">{{timetableRow.station}}</td>
          <td style="width: 70px;" class="border-top-0"></td>
          <td style="width: 90px;" class="border-top-0">
            <ng-container *ngIf="!timetableRow.stop">-</ng-container>
          </td>
          <td style="width: 170px" class="border-top-0">
            <div>
              <ng-container>{{timetableRow.schedule | qmDateFormat:'HH:mm'}}</ng-container>
              <ng-container *ngIf="timetableRow.actual; else depElseBlock">
                <i class="far fa-arrow-right"></i>
                {{timetableRow.actual | qmDateFormat:'HH:mm'}}
                <span class="badge badge-pill" [ngClass]="getDeltaClass(timetableRow.diff, true)"><span>{{timetableRow.diff}}</span></span>
              </ng-container>
              <ng-template #depElseBlock>
                <span [ngClass]="getDeltaClass(timetableRow.diff, false)">
                  {{getForecast(timetableRow.schedule, timetableRow.diff)}}
                </span>
              </ng-template>
            </div>
          </td>
          <td class="border-top-0">
            <ng-container *ngIf="!timetableRow.stop && latestStation(timetableRow)">
              {{'Departed' | translate}}
              <ng-container *ngIf="train.calculatedDelta !== timetableRow.diff">
                <span class="badge badge-pill" [ngClass]="getDeltaClass(train.calculatedDelta, true)"
                  ngbTooltip="{{'Estimate of train passage between measurement points' | translate }}">
                  <span>{{'Estimate' | translate}}: {{train.calculatedDelta}}</span>
                </span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="timetableRow.stop && latestStation(timetableRow) && train.calculatedDelta !== timetableRow.diff">
                <span class="badge badge-pill" [ngClass]="getDeltaClass(train.calculatedDelta, true)"
                  ngbTooltip="{{'Estimate of train passage between measurement points' | translate }}">
                  <span>{{'Estimate' | translate}}: {{train.calculatedDelta}}</span>
                </span>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      </tbody>
    </table>
  </div>
</div>
